import { React, Component } from 'utils';
import Page from './Page';
import { Creators, ResumeStore } from 'model';
import './pager.less';

export default class Pager extends Component {

	constructor(props)
	{
		super(props);
	}

	handleNext(event) {
		event.preventDefault();
		Creators.nextPage();
	}

	handlePrevious(event) {
		event.preventDefault();
		Creators.previousPage();
	}

	render() {
		var { pages, onClick } = this.props;
		var { page, pageCount } = ResumeStore.getState();
		
		var links = pages.map(function(page, index) {
			return <Page key={index} model={page} onClick={onClick} />
		});

		var noCallback = function() {

		};

		var previous = noCallback;
		var previousCss = 'disabled';

		var next = noCallback;
		var nextCss = 'disabled';

		if(page > 0) {
			previous = this.handlePrevious;
			previousCss = '';
		}

		if(page < pageCount - 1) {
			next = this.handleNext;
			nextCss = '';
		}

		return <ul className="pagination">
			<li className={previousCss}><a href="#" onClick={previous}><i className="fa fa-chevron-left"></i></a></li>
			{links}
			<li className={nextCss}><a href="#" onClick={next}><i className="fa fa-chevron-right"></i></a></li>
		</ul>
	}
}



// WEBPACK FOOTER //
// ./src/modules/app/resumes/Pager.js